import React, { useState } from 'react';
import { useConversation } from '@elevenlabs/react';
import './CallPage.css';

const AGENT_ID = 'agent_5601kmhp3xjsenfaw1qdpgpkzh7j';
const AVATAR_URL = 'https://storage.googleapis.com/chaimate-characters/govt%20.jpeg';

const GujaratGovtCallPage = () => {
  const [isConnecting, setIsConnecting] = useState(false);

  const conversation = useConversation({
    onConnect: () => {
      setIsConnecting(false);
    },
    onDisconnect: () => {
      setIsConnecting(false);
    },
    onError: (error) => {
      if (!error.message?.includes('v1 RTC path not found')) {
        console.error('Call error:', error);
      }
      setIsConnecting(false);
    },
  });

  const { status, isSpeaking } = conversation;
  const isConnected = status === 'connected';

  const handleAnswer = async () => {
    if (isConnecting || status === 'connected' || status === 'connecting') return;
    setIsConnecting(true);
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await conversation.startSession({
        agentId: AGENT_ID,
        connectionType: 'websocket',
      });
    } catch (error) {
      console.error('Failed to start call:', error);
      setIsConnecting(false);
    }
  };

  const handleDecline = async () => {
    if (isConnected) {
      await conversation.endSession();
    } else {
      window.history.back();
    }
  };

  return (
    <div className="call-page">
      <div className="call-page-container">
        <div className={`call-avatar-wrapper ${isSpeaking ? 'speaking' : ''} ${isConnected ? 'connected' : ''}`}>
          <img src={AVATAR_URL} alt="Gujarat Government AI Expert" className="call-avatar" />
          {isConnected && (
            <div className="call-pulse-ring" />
          )}
        </div>

        <h1 className="call-name">Gujarat Government AI Expert</h1>
        <p className="call-status">
          {isConnecting
            ? 'Connecting...'
            : isConnected
            ? isSpeaking
              ? 'Speaking...'
              : 'Connected'
            : 'Incoming Call'}
        </p>

        <div className="call-actions">
          <button
            className="call-btn call-btn-decline"
            onClick={handleDecline}
            title={isConnected ? 'End Call' : 'Decline'}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91" />
              <line x1="23" y1="1" x2="1" y2="23" />
            </svg>
          </button>

          {!isConnected && (
            <button
              className={`call-btn call-btn-answer ${isConnecting ? 'connecting' : ''}`}
              onClick={handleAnswer}
              disabled={isConnecting}
              title="Answer"
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GujaratGovtCallPage;
